define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Cpf = (function () {
        function Cpf(cpf) {
            var _a, _b;
            if (((_a = cpf === null || cpf === void 0 ? void 0 : cpf.length) !== null && _a !== void 0 ? _a : 0) == 0)
                this._value = null;
            this._value = (_b = cpf === null || cpf === void 0 ? void 0 : cpf.replace(/\D/g, '').trim()) !== null && _b !== void 0 ? _b : null;
        }
        Object.defineProperty(Cpf.prototype, "value", {
            get: function () {
                return this._value;
            },
            enumerable: false,
            configurable: true
        });
        Cpf.prototype.IsValid = function () {
            return Cpf.IsValid(this.value);
        };
        Cpf.IsValid = function (cpf) {
            var _a;
            if (!cpf || ((_a = cpf === null || cpf === void 0 ? void 0 : cpf.length) !== null && _a !== void 0 ? _a : 0) != 11) {
                return false;
            }
            if ((cpf == '00000000000') || (cpf == '11111111111') || (cpf == '22222222222') || (cpf == '33333333333') || (cpf == '44444444444') || (cpf == '55555555555') || (cpf == '66666666666') || (cpf == '77777777777') || (cpf == '88888888888') || (cpf == '99999999999')) {
                return false;
            }
            var numero = 0;
            var caracter = '';
            var numeros = '0123456789';
            var j = 10;
            var somatorio = 0;
            var resto = 0;
            var digito1 = 0;
            var digito2 = 0;
            var cpfAux = '';
            cpfAux = cpf.substring(0, 9);
            for (var i = 0; i < 9; i++) {
                caracter = cpfAux.charAt(i);
                if (numeros.search(caracter) == -1) {
                    return false;
                }
                numero = Number(caracter);
                somatorio = somatorio + (numero * j);
                j--;
            }
            resto = somatorio % 11;
            digito1 = 11 - resto;
            if (digito1 > 9) {
                digito1 = 0;
            }
            j = 11;
            somatorio = 0;
            cpfAux = cpfAux + digito1;
            for (var i = 0; i < 10; i++) {
                caracter = cpfAux.charAt(i);
                numero = Number(caracter);
                somatorio = somatorio + (numero * j);
                j--;
            }
            resto = somatorio % 11;
            digito2 = 11 - resto;
            if (digito2 > 9) {
                digito2 = 0;
            }
            cpfAux = cpfAux + digito2;
            if (cpf != cpfAux) {
                return false;
            }
            else {
                return true;
            }
        };
        return Cpf;
    }());
    exports.default = Cpf;
});
